//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CenterComponent from "./player/page/center";
import Youtube from "./player/page/Youtube";

export default {
    props: ['url'],
    components: {
        Youtube: Youtube,
        CenterComponent: CenterComponent
    },
    data: function data() {
        return {
            loading: true,
            pages: [],
            page: [],
            pageIndex: 0,
            infoTitle: ''
        };
    },
    created: function created() {
        var _this = this;

        axios.get(this.url).then(function (responseData) {
            var data = responseData.data;
            _this.infoTitle = data.title;
            _this.pages = data.pages;

            _this.showPage(0);
            _this.loading = false;
        }).catch(function (err) {
            console.log(err);
        });
    },

    methods: {
        showPage: function showPage(index) {
            if (this.pages.length < 1) {
                return;
            }
            if (index >= this.pages.length) {
                index = this.pages.length - 1;
            }
            if (index < 0) {
                index = 0;
            }

            this.pageIndex = index;
            this.page = this.pages[index];
        },
        goToNextPage: function goToNextPage() {
            this.showPage(this.pageIndex + 1);
        },
        goToPreviousPage: function goToPreviousPage() {
            this.showPage(this.pageIndex - 1);
        }
    },
    computed: {
        canGoBack: function canGoBack() {
            return this.pageIndex !== 0;
        },
        canGoForward: function canGoForward() {
            if (this.pages.length < this.pageIndex) {
                return false;
            }
            return this.pages[this.pageIndex + 1] !== undefined;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Info.vue
// module id = 50
// module chunks = 0